export const REMOVE_ITEM = "REMOVE_ITEM";
export const INC_ITEM = "INC_ITEM";
export const DEC_ITEM = "DEC_ITEM";
export const ADD_ITEM = "ADD_ITEM";
export const CLEAR_CART = "CLEAR_CART";
